import { format } from "date-fns";

import { type ActivityLogResponse } from "../api";
import { Utility } from "./utility";

export interface ActivityLog extends ActivityLogResponse {}

export class ActivityLog extends Utility<ActivityLog> {
  constructor(init?: Partial<ActivityLogResponse>) {
    super();
    Object.assign(this, init);
  }

  get created_at_datetime_string(): string | null {
    if (this.created_at === null || this.created_at === undefined) return null;
    return format(this.created_at, "MMM d, hh:mm aaa");
  }
}
